import React, { useEffect, useState } from "react";
/* COMPONENTS */
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

/* LAB */
import { LoadingButton } from '@mui/lab';
/* REQUEST */
import { getUserById, getTags, assignExtraTags } from 'utils/Users';
/* TRANSLATE */
import { useTranslation } from "react-i18next";
/* ICONS */
import CloseIcon from '@mui/icons-material/Close';



const ExtraTag = ({ open, setOpen, setAlert, setOpenAlert, setContextMenu, reloading, selected, setSelectedRow }) => {

    const { t } = useTranslation();
    const [checked, setChecked] = useState([]);
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [leftSearch, setLeftSearch] = useState('');
    const [rightSearch, setRightSearch] = useState('');
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const request = async () => {
            try {
                setLoading(true);
                const [users, tags] = await Promise.allSettled([
                    getUserById(setLoading, selected[0]),
                    getTags(setLoading),
                ]);

                if(users.status === 'fulfilled' && tags.status === 'fulfilled') {
                    const userData = users.value?.data || {};
                    const tagsData = tags.value?.data || [];

                    // Asegurarse de que extra_tags existe y es un array
                    const userExtraTags = Array.isArray(userData.extra_tags) ? userData.extra_tags : [];

                    // Obtener los tags activos (asignados al usuario)
                    const activeExtraTags = tagsData.filter(tag =>
                        userExtraTags.some(userTag =>
                            userTag.tag_id === tag.tag_id && userTag.is_aggregation === true
                        )
                    );
                    console.log('activeExtraTags', activeExtraTags);
                    setRight(activeExtraTags);

                    // Obtener los tags disponibles (no asignados al usuario)
                    const filteredTags = tagsData.filter(tag =>
                        !activeExtraTags.some(userTag => userTag.tag_id === tag.tag_id)
                    );
                    console.log('filteredTags', filteredTags);
                    setLeft(filteredTags);
                }
            } catch (error) {
                console.error('Error fetching tags:', error.message);
            } finally {
                setLoading(false);
            }
        };

        if (open && selected.length > 0) {
            request();
        }
    }, [open, selected]);


    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleCheckedRight = () => {
        const filteredLeftChecked = left
            .filter(tag =>
                tag.tag_name.toLowerCase().includes(leftSearch.toLowerCase()) &&
                checked.includes(tag.tag_id)
            );

        setRight([...right, ...filteredLeftChecked]);
        setLeft(left.filter(tag => !filteredLeftChecked.some(checkedTag => checkedTag.tag_id === tag.tag_id)));
        setChecked(checked.filter(id => !filteredLeftChecked.some(tag => tag.tag_id === id)));
    };

    const handleCheckedLeft = () => {
        const filteredRightChecked = right
            .filter(tag =>
                tag.tag_name.toLowerCase().includes(rightSearch.toLowerCase()) &&
                checked.includes(tag.tag_id)
            );

        setLeft([...left, ...filteredRightChecked]);
        setRight(right.filter(tag => !filteredRightChecked.some(checkedTag => checkedTag.tag_id === tag.tag_id)));
        setChecked(checked.filter(id => !filteredRightChecked.some(tag => tag.tag_id === id)));
    };



    const clearForm = () => {
        setOpen(false);
        setChecked([]);
        setLeft([]);
        setRight([]);
        setLeftSearch('');
        setRightSearch('');

    }


    const customList = (title, tags, searchValue, setSearchValue) => {
        // Filtrar tags basado en la búsqueda
        const filteredTags = Array.isArray(tags) ? tags.filter(tag => {
            // Validar que el tag existe y tiene la propiedad name
            if (!tag || typeof tag.tag_name !== 'string') {
                return false;
            }
            return tag.tag_name.toLowerCase().includes((searchValue || '').toLowerCase());
        }) : [];

        return (
            <Card>
                <CardHeader
                    sx={{ px: 2, py: 1 }}
                    title={title}
                    subheader={`${tags.length} ${t('user_management.table.dialog.extra_tag.tags')}`}
                />
                <Divider />
                <TextField
                    placeholder={t('user_management.table.dialog.extra_tag.search')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{ px: 2, py: 1 }}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
                <List
                    sx={{
                        width: '100%',
                        height: 300,
                        maxWidth: 360,
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        maxHeight: 300,
                    }}
                >
                    {loading ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%'
                        }}>
                            <CircularProgress size={25} color="inherit" />
                        </div>
                    ) : (
                        filteredTags.map((tag) => (
                            <ListItemButton
                                key={tag.tag_id}
                                role="listitem"
                                onClick={handleToggle(tag.tag_id)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.includes(tag.tag_id)}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={tag.tag_name}
                                />
                            </ListItemButton>
                        ))
                    )}
                </List>
            </Card>
        );
    };

    const assignTags = async () => {
        try {
            setLoading(true);

            const tagsToAssign = right.map(tag => ({
                name: tag.tag_name,
                tag_id: tag.tag_id
            }));

            const body = {
                tags: tagsToAssign
            };

            const response = await assignExtraTags(setLoading, body, selected[0]);

            if (response.status === 200) {
                setAlert({
                    msg: t('user_management.table.dialog.extra_tag.messages.success'),
                    severity: 'success'
                });
                setOpenAlert(true);
                setContextMenu(false);
                setSelectedRow([]);
                clearForm();
                reloading();
            }
        } catch (error) {
            setAlert({
                msg: t('user_management.table.dialog.extra_tag.messages.error'),
                severity: 'error'
            });
            setOpenAlert(true);
            console.error('Error asignando tags:', error.message);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Dialog
            open={open}
            onClose={() => clearForm()}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>{t('user_management.table.dialog.extra_tag.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => clearForm()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <Grid
                    container
                    spacing={2}
                    sx={{ justifyContent: 'center', alignItems: 'center' }}
                >
                    <Grid item xs={5}>{customList(t('user_management.table.dialog.extra_tag.available_list'), left)}</Grid>
                    <Grid item>
                        <Grid container direction="column" sx={{ alignItems: 'center' }}>
                            <Button
                                sx={{ my: 0.5 }}
                                variant="outlined"
                                size="small"
                                onClick={handleCheckedRight}
                                disabled={left.filter(tag => checked.includes(tag.tag_id)).length === 0}
                                aria-label="move selected right"
                            >
                                &gt;
                            </Button>
                            <Button
                                sx={{ my: 0.5 }}
                                variant="outlined"
                                size="small"
                                onClick={handleCheckedLeft}
                                disabled={right.filter(tag => checked.includes(tag.tag_id)).length === 0}
                                aria-label="move selected left"
                            >
                                &lt;
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={5}>{customList(t('user_management.table.dialog.extra_tag.assigned_list'), right)}</Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => clearForm()} color="error" variant='outlined'>
                    {t('user_management.table.dialog.extra_tag.buttons.cancel')}
                </Button>
                <LoadingButton loading={loading} onClick={() => assignTags()} color="primary">
                    {t('user_management.table.dialog.extra_tag.buttons.assign')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
export { ExtraTag };